<template>
<!--  -------查询框组件------ -->
    <el-form  class="demo-form-inline Query_box" ref="formQuery" :model="queryVal" onsubmit="return false;" :inline="true" size="mini" :label-width="labelWidth" >
        <el-form-item v-for="(item, index) in formInlines" :key="index" :label="item.label" :prop="item.prop">
            <template v-if="item.type == 'input'">
                <el-input v-model.trim="queryVal[item.prop]" class="input-w input_appends" @blur="iccidToUppercase(item.label, item.prop)"  :placeholder="item.pleas" clearable>
                    <div v-if="item.more" slot="append" class="cursors clickCur"  @click="focusBox(item.label)">
                        <i v-if="!item.itemIndex" class="el-icon-more "></i>
                        <i class="el-icon-check them-color-i " style="font-weight:700;" v-else></i>
                    </div>
                </el-input>
            </template>
            <template v-else-if="item.type == 'nums'">
                <el-input-number v-model="queryVal[item.prop]" class="input-w" :min="1" :max="9999999" :step="1" :precision="0"></el-input-number>
            </template>
            <template v-else-if="item.type == 'Tnums'">
                <el-input v-model="queryVal[item.prop]" class="input-w" @input="(val)=> queryVal[item.prop] = val.replace(/[^\d]/g, '')" :maxlength="20"></el-input>
            </template>
            <template v-else-if="item.type == 'amountSegment'">
                <el-input-number v-model="queryVal[item.prop1]" style="width:81px;" :controls="false" :min="0" :max="1023"></el-input-number>
                <el-select v-model="queryVal[item.prop]" placeholder="请选择" style="width:74px;">
                    <el-option label="MB" value="MB"></el-option>
                    <el-option label="GB" value="GB"></el-option>
                    <el-option label="TB" value="TB"></el-option>
                </el-select>
                ～
                <el-input-number v-model="queryVal[item.prop2]" style="width:81px;" :controls="false" :min="0" :max="1023"></el-input-number>
                <el-select v-model="queryVal[item.prop]" placeholder="请选择" style="width:74px;">
                    <el-option label="MB" value="MB"></el-option>
                    <el-option label="GB" value="GB"></el-option>
                    <el-option label="TB" value="TB"></el-option>
                </el-select>
            </template>
            
            <template v-else-if="item.type == 'select'">
                <el-select v-if="item.flog == 1" v-model="queryVal[item.prop]"   filterable  class="input-w" clearable :disabled="item.disable?true:false" @focus="focusBox(item.label)">
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'a'+indexs" :label="optItem.name" :value="optItem.val?optItem.val:optItem.name">
                        <span style="float: left">{{ optItem.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ optItem.val?optItem.val:optItem.name }}</span>
                    </el-option> 
                </el-select>
                <el-select v-else-if="item.flog == 2" filterable remote v-model="queryVal[item.prop]"   clearable class="input-w" :loading="queryVal[item.loading]" :remote-method="remoteMethod">
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'a'+indexs" :label="optItem.name" :value="optItem.val?optItem.val:optItem.name"></el-option> 
                </el-select>
                <el-select v-else-if="item.flog == 3" filterable remote v-model="queryVal[item.prop]"   clearable class="input-w" :loading="queryVal[item.loading]" :remote-method="remoteMethod" :placeholder="item.pleas">
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'a'+indexs" :label="optItem.name" :value="optItem.name">
                        <span style="float: left">{{ optItem.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 12px">{{ optItem.val }}</span>
                    </el-option> 
                </el-select>
                 <el-select v-else-if="item.flog == 4" filterable remote v-model="queryVal[item.prop]"   clearable class="input-w" :loading="queryVal[item.loading]" :remote-method="remoteMethod" :placeholder="item.pleas">
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'a'+indexs" :label="optItem.name" :value="optItem.val">
                        <span style="float: left; font-size: 12px;">{{ optItem.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 12px;">{{ optItem.val }}</span>
                    </el-option> 
                </el-select>
                <el-select v-else v-model="queryVal[item.prop]" filterable   class="input-w" clearable :disabled="item.disable?true:false" @focus="focusBox(item.label)">
                    <el-option v-for="(optItem ,indexs) in item.opt" :key="'a'+indexs" :label="optItem.name?optItem.name:optItem.val" :value="optItem.val?optItem.val:optItem.name"></el-option> 
                </el-select>
            </template>
            <template v-else-if="item.type == 'flows'">
               <el-input style="width:340px;" v-model="queryVal[item.prop]" class="input-with-select" @input="focusBox(item.label)">
                    <el-select v-model="item.select" slot="append"  placeholder="请选择" style="width:130px;">
                        <el-option label="MB" value="MB"></el-option>
                        <el-option label="GB" value="GB"></el-option>
                        <el-option label="TB" value="TB"></el-option>
                    </el-select>
                </el-input>
            </template>
            
            <template v-else>
                <el-date-picker v-if="item.distinguish == 'time'"  class="input-w" v-model="queryVal[item.prop]"    type="daterange" range-separator="~" value-format="yyyy-MM-dd"></el-date-picker> 
                <el-date-picker v-else-if="item.distinguish == 'monthrange'"  class="input-w" v-model="queryVal[item.prop]"   type="monthrange" value-format="yyyy-MM"></el-date-picker> 
                <el-date-picker v-else-if="item.distinguish == 'month'"  class="input-w" v-model="queryVal[item.prop]"   type="month" value-format="yyyy-MM"></el-date-picker>     
                <el-date-picker v-else-if="item.distinguish == 'data'"  class="input-w" v-model="queryVal[item.prop]"   type="date" value-format="yyyy-MM-dd"></el-date-picker>
                <el-date-picker v-else-if="item.distinguish == 'dataRang'" class="input-w" v-model="queryVal[item.prop]" :picker-options="item.pickerOptions" type="daterange" range-separator="~" value-format="yyyy-MM-dd"></el-date-picker>  
                <el-date-picker v-else class="input-w" v-model="queryVal[item.prop]"  :default-time="['00:00:00', '23:59:59']" :picker-options="item.pickerOptions" type="datetimerange" range-separator="~" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>   
            </template>
        </el-form-item>
    </el-form>
</template>  
<script>
 export default {
    name: 'queryBox',
    props: {
        formInlines: {
            type: Array,
        },
        labelWidth: {
            type: String,
            default: '100px'
        },
        queryVal: {
            type: Object,
        },
    },
    methods:{
        clearF(){
            //清空表单
            this.$refs.formQuery.resetFields();
        },
        focusBox(type){
            this.$emit('focusBox',type);
        },
        remoteMethod(query){
            this.$emit('remoteMethod',query);
        },
        iccidToUppercase(type, prop){
            if(type == 'ICCID'){
                this.queryVal[prop] = this.queryVal[prop].toUpperCase()
            }
        }
    }
 }
</script>
<style scoped>
    .clickCur{
        padding:0 14px;
        height: 26px;
        line-height: 26px;
    }
</style>
<style>
.input_appends .el-input-group__append{
    padding:0;
}
</style>



// WEBPACK FOOTER //
// src/publicComponents/queryBox.vue